module.exports = __webpack_public_path__ + "img/Jupiter.1a0e3129.png";